import Donate from '@/vue/_components/_site/donate/donate.web.vue'

jdw.components.Donate = Donate
import './donate.vue.js'
